import { types } from "../types/types";

const initialState = {
  loading: false,
  axis: "none",
  segmenting: false,
  module: null,
  role: null,
  eligibleUsers: [],
  groups: [],
  availableKeys: []
};

export const flowCoverageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_COVERAGE_SET_LOADING: {
      const reset = action.payload && typeof action.payload === "object"
        ? !!action.payload.reset
        : false;
      const loading = action.payload && typeof action.payload === "object"
        ? !!action.payload.loading
        : !!action.payload;
      if (loading && reset) {
        return { ...initialState, loading: true };
      }
      return { ...state, loading };
    }
    case types.FLOW_COVERAGE_PATCH_MEMBER: {
      const memberId = Number(action.payload?.id);
      const changes = action.payload?.changes || {};
      return {
        ...state,
        groups: (state.groups || []).map((group) => ({
          ...group,
          FlowCoverageMember_To_FlowCoverageGroup: (group.FlowCoverageMember_To_FlowCoverageGroup || []).map((member) => (
            Number(member.id) === memberId
              ? { ...member, ...changes }
              : member
          ))
        }))
      };
    }
    case types.FLOW_COVERAGE_SET:
      return {
        ...state,
        axis: action.payload.axis || "none",
        segmenting: !!action.payload.segmenting,
        module: action.payload.module || null,
        role: action.payload.role || null,
        eligibleUsers: action.payload.eligibleUsers || [],
        groups: action.payload.flowCoverageGroups || [],
        availableKeys: action.payload.availableKeys || []
      };
    default:
      return state;
  }
};
